// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskDetail-module__root___nWvUV {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 12px;
}

.TaskDetail-module__readinessBanner___S4yJE {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 12px;
  background: #fafafa;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.TaskDetail-module__readinessBanner___S4yJE:hover {
  background: #f4f4f5;
  border-color: #a1a1aa;
}

.TaskDetail-module__readinessBanner___S4yJE:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__readinessBannerArrow___IN5mT {
  color: #a1a1aa;
  font-size: 14px;
  line-height: 1;
  flex-shrink: 0;
}

.TaskDetail-module__readinessBannerBody___ui9SP {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.TaskDetail-module__readinessBannerLabel___jAM0z {
  font-size: 12px;
  font-weight: 600;
  color: #a1a1aa;
  line-height: 1.2;
}

.TaskDetail-module__readinessBannerTitle___VYCQr {
  font-size: 13px;
  font-weight: 600;
  color: #52525b;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskDetail-module__unclaimedBanner___Uu_dM {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #fefce8;
  border-top: 1px solid #fde68a;
  border-bottom: 1px solid #fde68a;
}

.TaskDetail-module__claimedBanner___Cwl0n {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 16px;
  background: #f0fdf4;
  border-top: 1px solid #bbf7d0;
  border-bottom: 1px solid #bbf7d0;
}

.TaskDetail-module__viewOnlyBanner___LEMe8 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 16px;
  background: #fafafa;
  border-top: 1px solid #e4e4e7;
  border-bottom: 1px solid #e4e4e7;
}

.TaskDetail-module__blockedBanner___f5Ng4 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #fafafa;
  border-top: 1px solid #e4e4e7;
  border-bottom: 1px solid #e4e4e7;
}

.TaskDetail-module__completedBanner___qP_6H {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 16px;
  background: #f0fdf4;
  border-top: 1px solid #bbf7d0;
  border-bottom: 1px solid #bbf7d0;
}

.TaskDetail-module__blockedStatusBanner___VGCDe {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #fef2f2;
  border-top: 1px solid #fecaca;
  border-bottom: 1px solid #fecaca;
}

.TaskDetail-module__escalatedStatusBanner___ZIBDQ {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #fffbeb;
  border-top: 1px solid #fde68a;
  border-bottom: 1px solid #fde68a;
}

.TaskDetail-module__unclaimedBannerCopy___KsOXK {
  flex: 1;
  min-width: 0;
}

.TaskDetail-module__claimedBannerCopy___nU7EE {
  flex: 1;
  min-width: 0;
}

.TaskDetail-module__blockedBannerCopy___zX_R1 {
  flex: 1;
  min-width: 0;
}

.TaskDetail-module__blockedStatusCopy___XgUL1 {
  flex: 1;
  min-width: 0;
}

.TaskDetail-module__escalatedStatusCopy___XX7do {
  flex: 1;
  min-width: 0;
}

.TaskDetail-module__blockedBannerIconWrap___Ghhy6 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #a1a1aa;
}

.TaskDetail-module__blockedStatusIconWrap___zGhwZ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #ef4444;
}

.TaskDetail-module__escalatedStatusIconWrap___gRTrI {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #f59e0b;
}

.TaskDetail-module__blockedBannerIcon___xiAb9 {
  width: 14px;
  height: 14px;
  stroke-width: 2;
}

.TaskDetail-module__blockedStatusIcon___kz1Bt {
  width: 14px;
  height: 14px;
  stroke-width: 2;
}

.TaskDetail-module__escalatedStatusIcon___uQbTb {
  width: 14px;
  height: 14px;
  stroke-width: 2;
}

.TaskDetail-module__unclaimedLabel___CCP_L {
  font-size: 12px;
  font-weight: 600;
  color: #a16207;
}

.TaskDetail-module__unclaimedText___clcKS {
  font-size: 10px;
  color: #a1a1aa;
  line-height: 1.4;
  margin-top: 2px;
}

.TaskDetail-module__viewOnlyLabel___n_Azd {
  font-size: 11px;
  font-weight: 500;
  color: #a1a1aa;
}

.TaskDetail-module__viewOnlyClaimLink___tkdGC {
  padding: 0;
  border: none;
  background: transparent;
  color: #18181b;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: underline;
  cursor: pointer;
}

.TaskDetail-module__claimedLabel___IKRXJ {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #166534;
}

.TaskDetail-module__claimedDot___vN0xw {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #22c55e;
  flex-shrink: 0;
}

.TaskDetail-module__blockedLabel___msHYi {
  font-size: 12px;
  font-weight: 600;
  color: #52525b;
}

.TaskDetail-module__blockedWaitingText___M7P3z {
  margin-top: 2px;
  font-size: 11px;
  line-height: 1.35;
  color: #a1a1aa;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskDetail-module__blockedWaitingLabel___Iqkdz {
  font-weight: 500;
}

.TaskDetail-module__blockedStatusTitle___Rbevm {
  font-size: 14px;
  font-weight: 600;
  color: #b91c1c;
}

.TaskDetail-module__blockedStatusMeta___NV05B {
  margin-top: 2px;
  font-size: 12px;
  line-height: 1.35;
  color: #f87171;
}

.TaskDetail-module__escalatedStatusTitle___GnGMO {
  font-size: 14px;
  font-weight: 600;
  color: #b45309;
}

.TaskDetail-module__escalatedStatusMeta___UFQEP {
  margin-top: 2px;
  font-size: 12px;
  line-height: 1.35;
  color: #d97706;
}

.TaskDetail-module__blockedStatusAction___ryvop {
  padding: 2px 6px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #ef4444;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.TaskDetail-module__blockedStatusAction___ryvop:hover,
.TaskDetail-module__blockedStatusAction___ryvop:focus-visible {
  background: #fee2e2;
  color: #b91c1c;
  outline: none;
}

.TaskDetail-module__escalatedStatusAction___SsuzA {
  padding: 2px 6px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #d97706;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.TaskDetail-module__escalatedStatusAction___SsuzA:hover,
.TaskDetail-module__escalatedStatusAction___SsuzA:focus-visible {
  background: #fef3c7;
  color: #92400e;
  outline: none;
}

.TaskDetail-module__completedLabel___EDMgd {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #166534;
}

.TaskDetail-module__completedCheck___J_qDv {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #dcfce7;
  color: #166534;
  font-size: 12px;
  font-weight: 700;
}

.TaskDetail-module__priorityBadge___ADfFk {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 11px;
  line-height: 1.2;
  white-space: nowrap;
}

.TaskDetail-module__priorityBadgecritical___JucaQ {
  background: #fee2e2;
  border-color: #fecaca;
  color: #b91c1c;
  font-weight: 600;
}

.TaskDetail-module__priorityBadgehigh___jyZfd {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #c2410c;
}

.TaskDetail-module__priorityBadgemedium___I6IMI {
  background: #fefce8;
  border-color: #fef08a;
  color: #a16207;
}

.TaskDetail-module__priorityBadgelow___gF1Z8 {
  background: #f9fafb;
  border-color: #e5e7eb;
  color: #6b7280;
}

.TaskDetail-module__claimedTime___MtNCK {
  font-size: 11px;
  color: #a1a1aa;
}

.TaskDetail-module__unclaimedBannerActions___fbYRt {
  display: flex;
  align-items: center;
  gap: 8px;
}

.TaskDetail-module__claimButton___AuLFq {
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  border: none;
  background: #18181b;
  color: #fafafa;
  cursor: pointer;
}

.TaskDetail-module__viewOnlyButton___LyLxF {
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #71717a;
  cursor: pointer;
}

.TaskDetail-module__sectionHeader___uGYNw {
  padding: 14px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.TaskDetail-module__headerTop___mUdWb {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
}

.TaskDetail-module__title___H5AXp {
  font-size: 15px;
  font-weight: 600;
  color: #18181b;
  line-height: 1.35;
  padding-right: 8px;
}

.TaskDetail-module__closeButton___IrhIh {
  background: none;
  border: none;
  font-size: 16px;
  color: #a1a1aa;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.TaskDetail-module__closeButton___IrhIh:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__caption___akEbw {
  font-size: 13px;
  color: #52525b;
  line-height: 1.5;
  margin-bottom: 8px;
}

.TaskDetail-module__badgesRow___TezKK {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.TaskDetail-module__sectionInfo___qfNKM {
  padding: 10px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.TaskDetail-module__infoGrid___wD8HU {
  display: grid;
  grid-template-columns: 72px 1fr;
  gap: 5px 0;
  font-size: 12px;
}

.TaskDetail-module__infoRow___gsytr {
  display: contents;
}

.TaskDetail-module__infoLabel___M9DCK {
  color: #a1a1aa;
  font-weight: 500;
}

.TaskDetail-module__infoValue___C5B4S {
  color: #3f3f46;
}

.TaskDetail-module__athenaLinkWrap___GbZ6E {
  margin-top: 8px;
}

.TaskDetail-module__sectionEvidence___yEDgJ {
  padding: 10px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.TaskDetail-module__sectionLabel___ySsR2 {
  font-size: 10px;
  font-weight: 600;
  color: #71717a;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 6px;
}

.TaskDetail-module__evidenceCard___oQa6e {
  background: #fafafa;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  padding: 10px 12px;
}

.TaskDetail-module__evidenceHeader___PGN03 {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 5px;
}

.TaskDetail-module__evidenceIcon___Tpi8r {
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  font-weight: 600;
}

.TaskDetail-module__evidenceLabel___WuCSN {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #52525b;
}

.TaskDetail-module__evidenceSpacer___Jw7SR {
  flex: 1;
}

.TaskDetail-module__evidenceRef___MDKDx {
  font-family: "IBM Plex Mono", monospace;
  font-size: 9px;
  color: #a1a1aa;
}

.TaskDetail-module__evidenceSummary___ZqYQK {
  font-size: 12px;
  line-height: 1.6;
  color: #3f3f46;
  margin: 0 0 6px;
}

.TaskDetail-module__evidenceSource___d4_fe {
  font-size: 10px;
  color: #a1a1aa;
}

.TaskDetail-module__sopSection___xjbMt {
  padding: 10px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.TaskDetail-module__sopButton___y6ipC {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #fafafa;
  color: #18181b;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.TaskDetail-module__sopButton___y6ipC:hover:not(:disabled) {
  border-color: #d4d4d8;
  background: #f4f4f5;
}

.TaskDetail-module__sopButton___y6ipC:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__sopButtonDisabled___Pa2Jv {
  cursor: not-allowed;
  opacity: 0.5;
}

.TaskDetail-module__sopButtonIcon___HDtLX {
  font-size: 14px;
  line-height: 1;
  flex-shrink: 0;
}

.TaskDetail-module__sopButtonLabel___DttCU {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  font-weight: 600;
  color: #18181b;
}

.TaskDetail-module__sopButtonArrow____jQJE {
  font-size: 13px;
  color: #a1a1aa;
  flex-shrink: 0;
}

.TaskDetail-module__assessmentSection___TsgVY {
  padding: 10px 16px;
  border-bottom: 1px solid #f4f4f5;
}

.TaskDetail-module__assessmentButton___fre_O {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #fafafa;
  color: #18181b;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.TaskDetail-module__assessmentButton___fre_O:hover:not(:disabled) {
  border-color: #d4d4d8;
  background: #f4f4f5;
}

.TaskDetail-module__assessmentButton___fre_O:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__assessmentButtonDisabled___YPr_a {
  cursor: not-allowed;
  opacity: 0.5;
}

.TaskDetail-module__assessmentButtonIcon___tNO_n {
  font-size: 14px;
  line-height: 1;
  flex-shrink: 0;
}

.TaskDetail-module__assessmentButtonLabel___JIgZA {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  font-weight: 600;
  color: #18181b;
}

.TaskDetail-module__assessmentButtonArrow___iEAfK {
  font-size: 13px;
  color: #a1a1aa;
  flex-shrink: 0;
}

.TaskDetail-module__sectionActions___bZ0yQ {
  display: flex;
  flex-direction: column;
}

.TaskDetail-module__primaryActionSection___EPr5z {
  padding: 12px 16px;
  background: #ffffff;
}

.TaskDetail-module__assessmentPrimaryActionsRow___qVijI {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 6px;
}

.TaskDetail-module__secondaryActionSection___bUWVZ {
  padding: 12px 16px;
  background: #fafafa;
  border-top: 1px solid #f4f4f5;
}

.TaskDetail-module__secondaryActionSectionStandalone___M9mT1 {
  border-top: none;
}

.TaskDetail-module__primaryAction___jWo7M {
  width: 100%;
  padding: 8px 0;
  margin-bottom: 2px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  border: none;
  background: #18181b;
  color: #fafafa;
  cursor: pointer;
}

.TaskDetail-module__primaryAction___jWo7M:disabled,
.TaskDetail-module__assessmentCompleteAction___WMNjw:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.TaskDetail-module__primaryAction___jWo7M:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__assessmentCompleteAction___WMNjw {
  width: 100%;
  padding: 8px 0;
  margin-bottom: 2px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #71717a;
  cursor: pointer;
}

.TaskDetail-module__assessmentCompleteAction___WMNjw:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__secondaryAction___Q7h19 {
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #71717a;
  cursor: pointer;
}

.TaskDetail-module__secondaryActionsRow___akDaS {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: nowrap;
}

.TaskDetail-module__secondaryActionsGroup___yIeXB {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  min-width: 0;
}

.TaskDetail-module__statusActionWrap___q688q {
  position: relative;
}

.TaskDetail-module__secondaryAction___Q7h19:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

@media (max-width: 720px) {
  .TaskDetail-module__secondaryActionsRow___akDaS {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .TaskDetail-module__secondaryActionsGroup___yIeXB {
    width: 100%;
    flex-wrap: wrap;
  }
}
.TaskDetail-module__statusAction___TOGYZ {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  border-radius: 6px;
  border: 1px solid currentColor;
  background: #ffffff;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.TaskDetail-module__statusActionDisabled___Tn_V9 {
  cursor: wait;
}

.TaskDetail-module__blockedAction___HYxNB {
  color: #ff4444;
}

.TaskDetail-module__blockedAction___HYxNB:hover,
.TaskDetail-module__blockedAction___HYxNB:focus-visible {
  background: #fef2f2;
}

.TaskDetail-module__escalateAction___um3o1 {
  color: #d97706;
}

.TaskDetail-module__escalateAction___um3o1:hover,
.TaskDetail-module__escalateAction___um3o1:focus-visible {
  background: #fffbeb;
}

.TaskDetail-module__statusActionActive___RzGhj {
  color: #ffffff;
}

.TaskDetail-module__blockedAction___HYxNB.TaskDetail-module__statusActionActive___RzGhj {
  background: #ff4444;
  border-color: #ff4444;
}

.TaskDetail-module__escalateAction___um3o1.TaskDetail-module__statusActionActive___RzGhj {
  background: #fbbf24;
  border-color: #fbbf24;
  color: #ffffff;
}

.TaskDetail-module__statusAction___TOGYZ:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__blockDropdown___TAMqT {
  position: absolute;
  right: 0;
  bottom: calc(100% + 8px);
  width: 200px;
  padding: 4px 0;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(24, 24, 27, 0.14);
  z-index: 10;
}

.TaskDetail-module__blockDropdownItem___x6C2y {
  width: 100%;
  padding: 10px 14px;
  border: none;
  background: transparent;
  color: #52525b;
  font-size: 14px;
  line-height: 1.2;
  text-align: left;
  cursor: pointer;
}

.TaskDetail-module__blockDropdownItem___x6C2y:hover,
.TaskDetail-module__blockDropdownItem___x6C2y:focus-visible {
  background: #fafafa;
  outline: none;
}

.TaskDetail-module__escalateDropdown___eSL46 {
  position: absolute;
  right: 0;
  bottom: calc(100% + 8px);
  width: 240px;
  padding: 12px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(24, 24, 27, 0.14);
  z-index: 10;
}

.TaskDetail-module__escalateDropdownLabel___LMItM {
  margin-bottom: 6px;
  color: #71717a;
  font-size: 12px;
  font-weight: 600;
}

.TaskDetail-module__escalateTargetOptions___OwQN3 {
  display: flex;
  gap: 6px;
  margin-bottom: 10px;
}

.TaskDetail-module__escalateTargetOption___GPXS3 {
  padding: 6px 8px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #ffffff;
  color: #52525b;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.TaskDetail-module__escalateTargetOption___GPXS3:hover,
.TaskDetail-module__escalateTargetOption___GPXS3:focus-visible {
  background: #fafafa;
  outline: none;
}

.TaskDetail-module__escalateTargetOptionActive___K94Li {
  background: #fef3c7;
  border-color: #fcd34d;
  color: #b45309;
  font-weight: 600;
}

.TaskDetail-module__escalateReasonInput___aFuAN {
  width: 100%;
  margin-bottom: 10px;
  padding: 8px 10px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  color: #18181b;
  font-size: 14px;
}

.TaskDetail-module__escalateReasonInput___aFuAN:focus {
  border-color: #f59e0b;
  outline: none;
}

.TaskDetail-module__escalateSubmitButton___XjcI5 {
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: #fbbf24;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.TaskDetail-module__escalateSubmitButton___XjcI5:hover,
.TaskDetail-module__escalateSubmitButton___XjcI5:focus-visible {
  background: #f59e0b;
  outline: none;
}

.TaskDetail-module__escalateSubmitButton___XjcI5:disabled {
  background: #fcd34d;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/TaskDetail/TaskDetail.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gEACE;AAAJ;;AAIA;EACE,mBAAA;EACA,qBAAA;AADF;;AAIA;EACE,0BAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,UAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,UAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADF;;AAIA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yDACE;AAFJ;;AAMA;;EAEE,mBAAA;EACA,cAAA;EACA,aAAA;AAHF;;AAMA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yDACE;AAJJ;;AAQA;;EAEE,mBAAA;EACA,cAAA;EACA,aAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AALF;;AAQA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AALF;;AAQA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AALF;;AAQA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AALF;;AAQA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AALF;;AAQA;EACE,eAAA;EACA,cAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AALF;;AAQA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AALF;;AAQA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AALF;;AAQA;EACE,kBAAA;EACA,gCAAA;AALF;;AAQA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AALF;;AAQA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;AALF;;AAQA;EACE,0BAAA;EACA,mBAAA;AALF;;AAQA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AALF;;AAQA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AALF;;AAQA;EACE,kBAAA;EACA,gCAAA;AALF;;AAQA;EACE,aAAA;EACA,+BAAA;EACA,UAAA;EACA,eAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,cAAA;EACA,gBAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE,kBAAA;EACA,gCAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AALF;;AAQA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AALF;;AAQA;EACE,uCAAA;EACA,eAAA;EACA,gBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AALF;;AAQA;EACE,OAAA;AALF;;AAQA;EACE,uCAAA;EACA,cAAA;EACA,cAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AALF;;AAQA;EACE,eAAA;EACA,cAAA;AALF;;AAQA;EACE,kBAAA;EACA,gCAAA;AALF;;AAQA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gEACE;AANJ;;AAUA;EACE,qBAAA;EACA,mBAAA;AAPF;;AAUA;EACE,0BAAA;EACA,mBAAA;AAPF;;AAUA;EACE,mBAAA;EACA,YAAA;AAPF;;AAUA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AAPF;;AAUA;EACE,OAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAPF;;AAUA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AAPF;;AAUA;EACE,kBAAA;EACA,gCAAA;AAPF;;AAUA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gEACE;AARJ;;AAYA;EACE,qBAAA;EACA,mBAAA;AATF;;AAYA;EACE,0BAAA;EACA,mBAAA;AATF;;AAYA;EACE,mBAAA;EACA,YAAA;AATF;;AAYA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AATF;;AAYA;EACE,OAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AATF;;AAYA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AATF;;AAYA;EACE,aAAA;EACA,sBAAA;AATF;;AAYA;EACE,kBAAA;EACA,mBAAA;AATF;;AAYA;EACE,aAAA;EACA,oDAAA;EACA,QAAA;AATF;;AAYA;EACE,kBAAA;EACA,mBAAA;EACA,6BAAA;AATF;;AAYA;EACE,gBAAA;AATF;;AAYA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AATF;;AAYA;;EAEE,mBAAA;EACA,YAAA;AATF;;AAYA;EACE,0BAAA;EACA,mBAAA;AATF;;AAYA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AATF;;AAYA;EACE,0BAAA;EACA,mBAAA;AATF;;AAYA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,iBAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;AATF;;AAYA;EACE,kBAAA;AATF;;AAYA;EACE,0BAAA;EACA,mBAAA;AATF;;AAYA;EACE;IACE,uBAAA;IACA,eAAA;EATF;EAYA;IACE,WAAA;IACA,eAAA;EAVF;AACF;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,kFACE;AAZJ;;AAiBA;EACE,YAAA;AAdF;;AAiBA;EACE,cAAA;AAdF;;AAiBA;;EAEE,mBAAA;AAdF;;AAiBA;EACE,cAAA;AAdF;;AAiBA;;EAEE,mBAAA;AAdF;;AAiBA;EACE,cAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,qBAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAdF;;AAiBA;EACE,0BAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,QAAA;EACA,wBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8CAAA;EACA,WAAA;AAdF;;AAiBA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAdF;;AAiBA;;EAEE,mBAAA;EACA,aAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,QAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8CAAA;EACA,WAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,kFACE;AAfJ;;AAoBA;;EAEE,mBAAA;EACA,aAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,qBAAA;EACA,aAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;AAjBF;;AAoBA;;EAEE,mBAAA;EACA,aAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,mBAAA;AAjBF","sourcesContent":[".root {\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 12px;\n}\n\n.readinessBanner {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  margin-bottom: 12px;\n  background: #fafafa;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  cursor: pointer;\n  text-align: left;\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease;\n}\n\n.readinessBanner:hover {\n  background: #f4f4f5;\n  border-color: #a1a1aa;\n}\n\n.readinessBanner:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.readinessBannerArrow {\n  color: #a1a1aa;\n  font-size: 14px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.readinessBannerBody {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.readinessBannerLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #a1a1aa;\n  line-height: 1.2;\n}\n\n.readinessBannerTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #52525b;\n  line-height: 1.35;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.unclaimedBanner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #fefce8;\n  border-top: 1px solid #fde68a;\n  border-bottom: 1px solid #fde68a;\n}\n\n.claimedBanner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #f0fdf4;\n  border-top: 1px solid #bbf7d0;\n  border-bottom: 1px solid #bbf7d0;\n}\n\n.viewOnlyBanner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #fafafa;\n  border-top: 1px solid #e4e4e7;\n  border-bottom: 1px solid #e4e4e7;\n}\n\n.blockedBanner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #fafafa;\n  border-top: 1px solid #e4e4e7;\n  border-bottom: 1px solid #e4e4e7;\n}\n\n.completedBanner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #f0fdf4;\n  border-top: 1px solid #bbf7d0;\n  border-bottom: 1px solid #bbf7d0;\n}\n\n.blockedStatusBanner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #fef2f2;\n  border-top: 1px solid #fecaca;\n  border-bottom: 1px solid #fecaca;\n}\n\n.escalatedStatusBanner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #fffbeb;\n  border-top: 1px solid #fde68a;\n  border-bottom: 1px solid #fde68a;\n}\n\n.unclaimedBannerCopy {\n  flex: 1;\n  min-width: 0;\n}\n\n.claimedBannerCopy {\n  flex: 1;\n  min-width: 0;\n}\n\n.blockedBannerCopy {\n  flex: 1;\n  min-width: 0;\n}\n\n.blockedStatusCopy {\n  flex: 1;\n  min-width: 0;\n}\n\n.escalatedStatusCopy {\n  flex: 1;\n  min-width: 0;\n}\n\n.blockedBannerIconWrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: #a1a1aa;\n}\n\n.blockedStatusIconWrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: #ef4444;\n}\n\n.escalatedStatusIconWrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: #f59e0b;\n}\n\n.blockedBannerIcon {\n  width: 14px;\n  height: 14px;\n  stroke-width: 2;\n}\n\n.blockedStatusIcon {\n  width: 14px;\n  height: 14px;\n  stroke-width: 2;\n}\n\n.escalatedStatusIcon {\n  width: 14px;\n  height: 14px;\n  stroke-width: 2;\n}\n\n.unclaimedLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #a16207;\n}\n\n.unclaimedText {\n  font-size: 10px;\n  color: #a1a1aa;\n  line-height: 1.4;\n  margin-top: 2px;\n}\n\n.viewOnlyLabel {\n  font-size: 11px;\n  font-weight: 500;\n  color: #a1a1aa;\n}\n\n.viewOnlyClaimLink {\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: #18181b;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.2;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.claimedLabel {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #166534;\n}\n\n.claimedDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: #22c55e;\n  flex-shrink: 0;\n}\n\n.blockedLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #52525b;\n}\n\n.blockedWaitingText {\n  margin-top: 2px;\n  font-size: 11px;\n  line-height: 1.35;\n  color: #a1a1aa;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.blockedWaitingLabel {\n  font-weight: 500;\n}\n\n.blockedStatusTitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: #b91c1c;\n}\n\n.blockedStatusMeta {\n  margin-top: 2px;\n  font-size: 12px;\n  line-height: 1.35;\n  color: #f87171;\n}\n\n.escalatedStatusTitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: #b45309;\n}\n\n.escalatedStatusMeta {\n  margin-top: 2px;\n  font-size: 12px;\n  line-height: 1.35;\n  color: #d97706;\n}\n\n.blockedStatusAction {\n  padding: 2px 6px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: #ef4444;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.blockedStatusAction:hover,\n.blockedStatusAction:focus-visible {\n  background: #fee2e2;\n  color: #b91c1c;\n  outline: none;\n}\n\n.escalatedStatusAction {\n  padding: 2px 6px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: #d97706;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.escalatedStatusAction:hover,\n.escalatedStatusAction:focus-visible {\n  background: #fef3c7;\n  color: #92400e;\n  outline: none;\n}\n\n.completedLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #166534;\n}\n\n.completedCheck {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  background: #dcfce7;\n  color: #166534;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.priorityBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px 6px;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  font-size: 11px;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.priorityBadgecritical {\n  background: #fee2e2;\n  border-color: #fecaca;\n  color: #b91c1c;\n  font-weight: 600;\n}\n\n.priorityBadgehigh {\n  background: #fff7ed;\n  border-color: #fed7aa;\n  color: #c2410c;\n}\n\n.priorityBadgemedium {\n  background: #fefce8;\n  border-color: #fef08a;\n  color: #a16207;\n}\n\n.priorityBadgelow {\n  background: #f9fafb;\n  border-color: #e5e7eb;\n  color: #6b7280;\n}\n\n.claimedTime {\n  font-size: 11px;\n  color: #a1a1aa;\n}\n\n.unclaimedBannerActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.claimButton {\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  border: none;\n  background: #18181b;\n  color: #fafafa;\n  cursor: pointer;\n}\n\n.viewOnlyButton {\n  padding: 6px 10px;\n  font-size: 11px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #d4d4d8;\n  background: #ffffff;\n  color: #71717a;\n  cursor: pointer;\n}\n\n.sectionHeader {\n  padding: 14px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.headerTop {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 4px;\n}\n\n.title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #18181b;\n  line-height: 1.35;\n  padding-right: 8px;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 16px;\n  color: #a1a1aa;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n}\n\n.closeButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.caption {\n  font-size: 13px;\n  color: #52525b;\n  line-height: 1.5;\n  margin-bottom: 8px;\n}\n\n.badgesRow {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.sectionInfo {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.infoGrid {\n  display: grid;\n  grid-template-columns: 72px 1fr;\n  gap: 5px 0;\n  font-size: 12px;\n}\n\n.infoRow {\n  display: contents;\n}\n\n.infoLabel {\n  color: #a1a1aa;\n  font-weight: 500;\n}\n\n.infoValue {\n  color: #3f3f46;\n}\n\n.athenaLinkWrap {\n  margin-top: 8px;\n}\n\n.sectionEvidence {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.sectionLabel {\n  font-size: 10px;\n  font-weight: 600;\n  color: #71717a;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 6px;\n}\n\n.evidenceCard {\n  background: #fafafa;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  padding: 10px 12px;\n}\n\n.evidenceHeader {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 5px;\n}\n\n.evidenceIcon {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.evidenceLabel {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #52525b;\n}\n\n.evidenceSpacer {\n  flex: 1;\n}\n\n.evidenceRef {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 9px;\n  color: #a1a1aa;\n}\n\n.evidenceSummary {\n  font-size: 12px;\n  line-height: 1.6;\n  color: #3f3f46;\n  margin: 0 0 6px;\n}\n\n.evidenceSource {\n  font-size: 10px;\n  color: #a1a1aa;\n}\n\n.sopSection {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.sopButton {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #fafafa;\n  color: #18181b;\n  cursor: pointer;\n  text-align: left;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease;\n}\n\n.sopButton:hover:not(:disabled) {\n  border-color: #d4d4d8;\n  background: #f4f4f5;\n}\n\n.sopButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.sopButtonDisabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.sopButtonIcon {\n  font-size: 14px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.sopButtonLabel {\n  flex: 1;\n  min-width: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.sopButtonArrow {\n  font-size: 13px;\n  color: #a1a1aa;\n  flex-shrink: 0;\n}\n\n.assessmentSection {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.assessmentButton {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #fafafa;\n  color: #18181b;\n  cursor: pointer;\n  text-align: left;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease;\n}\n\n.assessmentButton:hover:not(:disabled) {\n  border-color: #d4d4d8;\n  background: #f4f4f5;\n}\n\n.assessmentButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.assessmentButtonDisabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.assessmentButtonIcon {\n  font-size: 14px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.assessmentButtonLabel {\n  flex: 1;\n  min-width: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.assessmentButtonArrow {\n  font-size: 13px;\n  color: #a1a1aa;\n  flex-shrink: 0;\n}\n\n.sectionActions {\n  display: flex;\n  flex-direction: column;\n}\n\n.primaryActionSection {\n  padding: 12px 16px;\n  background: #ffffff;\n}\n\n.assessmentPrimaryActionsRow {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 6px;\n}\n\n.secondaryActionSection {\n  padding: 12px 16px;\n  background: #fafafa;\n  border-top: 1px solid #f4f4f5;\n}\n\n.secondaryActionSectionStandalone {\n  border-top: none;\n}\n\n.primaryAction {\n  width: 100%;\n  padding: 8px 0;\n  margin-bottom: 2px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  border: none;\n  background: #18181b;\n  color: #fafafa;\n  cursor: pointer;\n}\n\n.primaryAction:disabled,\n.assessmentCompleteAction:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.primaryAction:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.assessmentCompleteAction {\n  width: 100%;\n  padding: 8px 0;\n  margin-bottom: 2px;\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #e4e4e7;\n  background: #ffffff;\n  color: #71717a;\n  cursor: pointer;\n}\n\n.assessmentCompleteAction:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.secondaryAction {\n  padding: 6px 10px;\n  font-size: 11px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #d4d4d8;\n  background: #ffffff;\n  color: #71717a;\n  cursor: pointer;\n}\n\n.secondaryActionsRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: nowrap;\n}\n\n.secondaryActionsGroup {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n  min-width: 0;\n}\n\n.statusActionWrap {\n  position: relative;\n}\n\n.secondaryAction:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n@media (max-width: 720px) {\n  .secondaryActionsRow {\n    align-items: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .secondaryActionsGroup {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n}\n\n.statusAction {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 10px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1;\n  border-radius: 6px;\n  border: 1px solid currentColor;\n  background: #ffffff;\n  cursor: pointer;\n  white-space: nowrap;\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.statusActionDisabled {\n  cursor: wait;\n}\n\n.blockedAction {\n  color: #ff4444;\n}\n\n.blockedAction:hover,\n.blockedAction:focus-visible {\n  background: #fef2f2;\n}\n\n.escalateAction {\n  color: #d97706;\n}\n\n.escalateAction:hover,\n.escalateAction:focus-visible {\n  background: #fffbeb;\n}\n\n.statusActionActive {\n  color: #ffffff;\n}\n\n.blockedAction.statusActionActive {\n  background: #ff4444;\n  border-color: #ff4444;\n}\n\n.escalateAction.statusActionActive {\n  background: #fbbf24;\n  border-color: #fbbf24;\n  color: #ffffff;\n}\n\n.statusAction:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.blockDropdown {\n  position: absolute;\n  right: 0;\n  bottom: calc(100% + 8px);\n  width: 200px;\n  padding: 4px 0;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  box-shadow: 0 12px 28px rgba(24, 24, 27, 0.14);\n  z-index: 10;\n}\n\n.blockDropdownItem {\n  width: 100%;\n  padding: 10px 14px;\n  border: none;\n  background: transparent;\n  color: #52525b;\n  font-size: 14px;\n  line-height: 1.2;\n  text-align: left;\n  cursor: pointer;\n}\n\n.blockDropdownItem:hover,\n.blockDropdownItem:focus-visible {\n  background: #fafafa;\n  outline: none;\n}\n\n.escalateDropdown {\n  position: absolute;\n  right: 0;\n  bottom: calc(100% + 8px);\n  width: 240px;\n  padding: 12px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  box-shadow: 0 12px 28px rgba(24, 24, 27, 0.14);\n  z-index: 10;\n}\n\n.escalateDropdownLabel {\n  margin-bottom: 6px;\n  color: #71717a;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.escalateTargetOptions {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 10px;\n}\n\n.escalateTargetOption {\n  padding: 6px 8px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #52525b;\n  font-size: 12px;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.escalateTargetOption:hover,\n.escalateTargetOption:focus-visible {\n  background: #fafafa;\n  outline: none;\n}\n\n.escalateTargetOptionActive {\n  background: #fef3c7;\n  border-color: #fcd34d;\n  color: #b45309;\n  font-weight: 600;\n}\n\n.escalateReasonInput {\n  width: 100%;\n  margin-bottom: 10px;\n  padding: 8px 10px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  color: #18181b;\n  font-size: 14px;\n}\n\n.escalateReasonInput:focus {\n  border-color: #f59e0b;\n  outline: none;\n}\n\n.escalateSubmitButton {\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 6px;\n  background: #fbbf24;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.escalateSubmitButton:hover,\n.escalateSubmitButton:focus-visible {\n  background: #f59e0b;\n  outline: none;\n}\n\n.escalateSubmitButton:disabled {\n  background: #fcd34d;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `TaskDetail-module__root___nWvUV`,
	"readinessBanner": `TaskDetail-module__readinessBanner___S4yJE`,
	"readinessBannerArrow": `TaskDetail-module__readinessBannerArrow___IN5mT`,
	"readinessBannerBody": `TaskDetail-module__readinessBannerBody___ui9SP`,
	"readinessBannerLabel": `TaskDetail-module__readinessBannerLabel___jAM0z`,
	"readinessBannerTitle": `TaskDetail-module__readinessBannerTitle___VYCQr`,
	"unclaimedBanner": `TaskDetail-module__unclaimedBanner___Uu_dM`,
	"claimedBanner": `TaskDetail-module__claimedBanner___Cwl0n`,
	"viewOnlyBanner": `TaskDetail-module__viewOnlyBanner___LEMe8`,
	"blockedBanner": `TaskDetail-module__blockedBanner___f5Ng4`,
	"completedBanner": `TaskDetail-module__completedBanner___qP_6H`,
	"blockedStatusBanner": `TaskDetail-module__blockedStatusBanner___VGCDe`,
	"escalatedStatusBanner": `TaskDetail-module__escalatedStatusBanner___ZIBDQ`,
	"unclaimedBannerCopy": `TaskDetail-module__unclaimedBannerCopy___KsOXK`,
	"claimedBannerCopy": `TaskDetail-module__claimedBannerCopy___nU7EE`,
	"blockedBannerCopy": `TaskDetail-module__blockedBannerCopy___zX_R1`,
	"blockedStatusCopy": `TaskDetail-module__blockedStatusCopy___XgUL1`,
	"escalatedStatusCopy": `TaskDetail-module__escalatedStatusCopy___XX7do`,
	"blockedBannerIconWrap": `TaskDetail-module__blockedBannerIconWrap___Ghhy6`,
	"blockedStatusIconWrap": `TaskDetail-module__blockedStatusIconWrap___zGhwZ`,
	"escalatedStatusIconWrap": `TaskDetail-module__escalatedStatusIconWrap___gRTrI`,
	"blockedBannerIcon": `TaskDetail-module__blockedBannerIcon___xiAb9`,
	"blockedStatusIcon": `TaskDetail-module__blockedStatusIcon___kz1Bt`,
	"escalatedStatusIcon": `TaskDetail-module__escalatedStatusIcon___uQbTb`,
	"unclaimedLabel": `TaskDetail-module__unclaimedLabel___CCP_L`,
	"unclaimedText": `TaskDetail-module__unclaimedText___clcKS`,
	"viewOnlyLabel": `TaskDetail-module__viewOnlyLabel___n_Azd`,
	"viewOnlyClaimLink": `TaskDetail-module__viewOnlyClaimLink___tkdGC`,
	"claimedLabel": `TaskDetail-module__claimedLabel___IKRXJ`,
	"claimedDot": `TaskDetail-module__claimedDot___vN0xw`,
	"blockedLabel": `TaskDetail-module__blockedLabel___msHYi`,
	"blockedWaitingText": `TaskDetail-module__blockedWaitingText___M7P3z`,
	"blockedWaitingLabel": `TaskDetail-module__blockedWaitingLabel___Iqkdz`,
	"blockedStatusTitle": `TaskDetail-module__blockedStatusTitle___Rbevm`,
	"blockedStatusMeta": `TaskDetail-module__blockedStatusMeta___NV05B`,
	"escalatedStatusTitle": `TaskDetail-module__escalatedStatusTitle___GnGMO`,
	"escalatedStatusMeta": `TaskDetail-module__escalatedStatusMeta___UFQEP`,
	"blockedStatusAction": `TaskDetail-module__blockedStatusAction___ryvop`,
	"escalatedStatusAction": `TaskDetail-module__escalatedStatusAction___SsuzA`,
	"completedLabel": `TaskDetail-module__completedLabel___EDMgd`,
	"completedCheck": `TaskDetail-module__completedCheck___J_qDv`,
	"priorityBadge": `TaskDetail-module__priorityBadge___ADfFk`,
	"priorityBadgecritical": `TaskDetail-module__priorityBadgecritical___JucaQ`,
	"priorityBadgehigh": `TaskDetail-module__priorityBadgehigh___jyZfd`,
	"priorityBadgemedium": `TaskDetail-module__priorityBadgemedium___I6IMI`,
	"priorityBadgelow": `TaskDetail-module__priorityBadgelow___gF1Z8`,
	"claimedTime": `TaskDetail-module__claimedTime___MtNCK`,
	"unclaimedBannerActions": `TaskDetail-module__unclaimedBannerActions___fbYRt`,
	"claimButton": `TaskDetail-module__claimButton___AuLFq`,
	"viewOnlyButton": `TaskDetail-module__viewOnlyButton___LyLxF`,
	"sectionHeader": `TaskDetail-module__sectionHeader___uGYNw`,
	"headerTop": `TaskDetail-module__headerTop___mUdWb`,
	"title": `TaskDetail-module__title___H5AXp`,
	"closeButton": `TaskDetail-module__closeButton___IrhIh`,
	"caption": `TaskDetail-module__caption___akEbw`,
	"badgesRow": `TaskDetail-module__badgesRow___TezKK`,
	"sectionInfo": `TaskDetail-module__sectionInfo___qfNKM`,
	"infoGrid": `TaskDetail-module__infoGrid___wD8HU`,
	"infoRow": `TaskDetail-module__infoRow___gsytr`,
	"infoLabel": `TaskDetail-module__infoLabel___M9DCK`,
	"infoValue": `TaskDetail-module__infoValue___C5B4S`,
	"athenaLinkWrap": `TaskDetail-module__athenaLinkWrap___GbZ6E`,
	"sectionEvidence": `TaskDetail-module__sectionEvidence___yEDgJ`,
	"sectionLabel": `TaskDetail-module__sectionLabel___ySsR2`,
	"evidenceCard": `TaskDetail-module__evidenceCard___oQa6e`,
	"evidenceHeader": `TaskDetail-module__evidenceHeader___PGN03`,
	"evidenceIcon": `TaskDetail-module__evidenceIcon___Tpi8r`,
	"evidenceLabel": `TaskDetail-module__evidenceLabel___WuCSN`,
	"evidenceSpacer": `TaskDetail-module__evidenceSpacer___Jw7SR`,
	"evidenceRef": `TaskDetail-module__evidenceRef___MDKDx`,
	"evidenceSummary": `TaskDetail-module__evidenceSummary___ZqYQK`,
	"evidenceSource": `TaskDetail-module__evidenceSource___d4_fe`,
	"sopSection": `TaskDetail-module__sopSection___xjbMt`,
	"sopButton": `TaskDetail-module__sopButton___y6ipC`,
	"sopButtonDisabled": `TaskDetail-module__sopButtonDisabled___Pa2Jv`,
	"sopButtonIcon": `TaskDetail-module__sopButtonIcon___HDtLX`,
	"sopButtonLabel": `TaskDetail-module__sopButtonLabel___DttCU`,
	"sopButtonArrow": `TaskDetail-module__sopButtonArrow____jQJE`,
	"assessmentSection": `TaskDetail-module__assessmentSection___TsgVY`,
	"assessmentButton": `TaskDetail-module__assessmentButton___fre_O`,
	"assessmentButtonDisabled": `TaskDetail-module__assessmentButtonDisabled___YPr_a`,
	"assessmentButtonIcon": `TaskDetail-module__assessmentButtonIcon___tNO_n`,
	"assessmentButtonLabel": `TaskDetail-module__assessmentButtonLabel___JIgZA`,
	"assessmentButtonArrow": `TaskDetail-module__assessmentButtonArrow___iEAfK`,
	"sectionActions": `TaskDetail-module__sectionActions___bZ0yQ`,
	"primaryActionSection": `TaskDetail-module__primaryActionSection___EPr5z`,
	"assessmentPrimaryActionsRow": `TaskDetail-module__assessmentPrimaryActionsRow___qVijI`,
	"secondaryActionSection": `TaskDetail-module__secondaryActionSection___bUWVZ`,
	"secondaryActionSectionStandalone": `TaskDetail-module__secondaryActionSectionStandalone___M9mT1`,
	"primaryAction": `TaskDetail-module__primaryAction___jWo7M`,
	"assessmentCompleteAction": `TaskDetail-module__assessmentCompleteAction___WMNjw`,
	"secondaryAction": `TaskDetail-module__secondaryAction___Q7h19`,
	"secondaryActionsRow": `TaskDetail-module__secondaryActionsRow___akDaS`,
	"secondaryActionsGroup": `TaskDetail-module__secondaryActionsGroup___yIeXB`,
	"statusActionWrap": `TaskDetail-module__statusActionWrap___q688q`,
	"statusAction": `TaskDetail-module__statusAction___TOGYZ`,
	"statusActionDisabled": `TaskDetail-module__statusActionDisabled___Tn_V9`,
	"blockedAction": `TaskDetail-module__blockedAction___HYxNB`,
	"escalateAction": `TaskDetail-module__escalateAction___um3o1`,
	"statusActionActive": `TaskDetail-module__statusActionActive___RzGhj`,
	"blockDropdown": `TaskDetail-module__blockDropdown___TAMqT`,
	"blockDropdownItem": `TaskDetail-module__blockDropdownItem___x6C2y`,
	"escalateDropdown": `TaskDetail-module__escalateDropdown___eSL46`,
	"escalateDropdownLabel": `TaskDetail-module__escalateDropdownLabel___LMItM`,
	"escalateTargetOptions": `TaskDetail-module__escalateTargetOptions___OwQN3`,
	"escalateTargetOption": `TaskDetail-module__escalateTargetOption___GPXS3`,
	"escalateTargetOptionActive": `TaskDetail-module__escalateTargetOptionActive___K94Li`,
	"escalateReasonInput": `TaskDetail-module__escalateReasonInput___aFuAN`,
	"escalateSubmitButton": `TaskDetail-module__escalateSubmitButton___XjcI5`
};
module.exports = ___CSS_LOADER_EXPORT___;
